import { Link } from 'react-router-dom';
import { comics, categoryLabels } from '@/mocks/comics';

export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-file-list-2-line',
      title: '下拉式阅读',
      desc: '专为网页端优化的下拉式阅读体验，无需翻页，流畅阅读每一话内容',
    },
    {
      icon: 'ri-heart-add-line',
      title: '轻松追更收藏',
      desc: '一键收藏喜欢的漫画，更新提醒不迷路，追更体验从未如此简单',
    },
    {
      icon: 'ri-global-line',
      title: '韩漫日漫国漫',
      desc: '覆盖三大漫画类型，热门全集大全都在这，找漫画就来99漫画',
    },
    {
      icon: 'ri-shield-check-line',
      title: '免费安全可靠',
      desc: '类似4399漫画网的免费平台，严格筛选推荐，保障阅读安全',
    },
  ];

  const randomFeatured = comics.filter((c) => c.rating >= 9.2).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <i className="ri-sparkling-line text-accent-500 text-lg"></i>
            <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full whitespace-nowrap">为什么选择</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            99漫画，比4399漫画网更懂你
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
            我们用心打造最好的免费漫画推荐平台，让你找到真正值得阅读的好漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-12">
          {features.map((feat, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4">
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="text-center mb-8">
            <h3 className="font-heading text-xl text-foreground-900 mb-2">精选高分漫画推荐</h3>
            <p className="text-sm text-foreground-500">以下是评分最高的几部作品，每一部都是经得起考验的好漫画</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {randomFeatured.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="w-16 h-22 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 99漫画高分${categoryLabels[comic.category]}推荐`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-col justify-center min-w-0">
                  <h4 className="font-medium text-sm text-foreground-900 line-clamp-1">{comic.title}</h4>
                  <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{categoryLabels[comic.category]} · {comic.author}</p>
                  <div className="flex items-center gap-1 mt-1.5 text-accent-500">
                    <i className="ri-star-fill text-[10px]"></i>
                    <span className="text-xs font-medium">{comic.rating}</span>
                    <span className="text-[10px] text-foreground-400 ml-1 whitespace-nowrap">{comic.chapters}话</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}